import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/data/kalindi.dcpltechnology.com/src/app/privacy-policy/index.js");
